module.exports = __webpack_public_path__ + "static/media/1006550.6daaf3fa.png";